// ==========================================================================
// CACTUS KNIGHT — Farbvarianten-Auswahl (Produktseite)
// Die Swatches werden bereits server-seitig mit den echten Shopify-Varianten
// gerendert (siehe templates/product.liquid). Dieses Skript kümmert sich nur
// noch um Auswahl-Interaktion: aktiven Swatch markieren, Preis/Verfügbarkeit
// im Formular aktualisieren, versteckte Varianten-ID setzen (für den
// Add-to-Cart-Request), Stempel-Overlay auf dem Produktbild anpassen.
// Sobald echte Produktfotos pro Farbe hinterlegt sind, kann hier zusätzlich
// das Hauptbild gewechselt werden (variant.featured_image).
// ==========================================================================

document.addEventListener("DOMContentLoaded", () => {
  const selector = document.getElementById("variant-selector");
  const swatchesEl = document.getElementById("variant-swatches");
  const currentLabel = document.getElementById("variant-selector__current");
  const stampEl = document.getElementById("variant-stamp");
  const hiddenVariantInput = document.getElementById("product-selected-variant-id");
  const priceDisplay = document.getElementById("product-price-display");
  const soldOutBadge = document.getElementById("product-sold-out-badge");
  const addToCartBtn = document.getElementById("add-to-cart-btn");
  const stockStatusText = document.getElementById("stock-status-text");

  if (!selector || !swatchesEl) return;

  const swatches = Array.from(swatchesEl.querySelectorAll(".variant-swatch"));
  if (swatches.length === 0) return;

  function applyVariant(swatch) {
    const name = swatch.dataset.variantName;
    const available = swatch.dataset.variantAvailable === "true";
    const color = swatch.querySelector(".variant-swatch__inner").style.background;

    swatches.forEach((el) => el.classList.toggle("is-selected", el === swatch));

    if (currentLabel) {
      currentLabel.textContent = name;
      currentLabel.style.color = color;
    }

    if (stampEl) {
      stampEl.textContent = (name || "").toUpperCase() + "!";
      stampEl.style.color = color;
      stampEl.removeAttribute("hidden");
    }

    if (hiddenVariantInput) hiddenVariantInput.value = swatch.dataset.variantId;
    if (priceDisplay) priceDisplay.textContent = swatch.dataset.variantPrice;

    if (soldOutBadge) soldOutBadge.hidden = available;
    if (stockStatusText) stockStatusText.textContent = available ? "AUF LAGER" : "NICHT VORRÄTIG";
    if (addToCartBtn) {
      addToCartBtn.disabled = !available;
      addToCartBtn.classList.toggle("btn--disabled", !available);
      addToCartBtn.textContent = available ? "In den Warenkorb" : "Ausverkauft";
    }
  }

  // Hover-Vorschau des Labels, endgültige Auswahl per Klick
  swatches.forEach((swatch) => {
    swatch.addEventListener("mouseenter", () => {
      if (!currentLabel) return;
      currentLabel.textContent = swatch.dataset.variantName;
      currentLabel.style.color = swatch.querySelector(".variant-swatch__inner").style.background;
    });
    swatch.addEventListener("mouseleave", () => {
      const selected = swatchesEl.querySelector(".variant-swatch.is-selected");
      if (selected && currentLabel) {
        currentLabel.textContent = selected.dataset.variantName;
        currentLabel.style.color = selected.querySelector(".variant-swatch__inner").style.background;
      }
    });
    swatch.addEventListener("click", () => applyVariant(swatch));
  });

  const initiallySelected = swatchesEl.querySelector(".variant-swatch.is-selected") || swatches[0];
  applyVariant(initiallySelected);
});

// ---- Auswahlfeld über alle Varianten (nur bei Produkten mit mehreren
// Optionen, z. B. Farbe + Größe — dort reichen Farb-Swatches nicht aus) ----
document.addEventListener("DOMContentLoaded", () => {
  const select = document.getElementById("variant-full-select");
  if (!select) return;

  const hiddenVariantInput = document.getElementById("product-selected-variant-id");
  const priceDisplay = document.getElementById("product-price-display");
  const soldOutBadge = document.getElementById("product-sold-out-badge");
  const addToCartBtn = document.getElementById("add-to-cart-btn");
  const stockStatusText = document.getElementById("stock-status-text");

  function applySelection() {
    const opt = select.options[select.selectedIndex];
    if (!opt) return;
    const available = opt.dataset.variantAvailable === "true";

    if (hiddenVariantInput) hiddenVariantInput.value = opt.value;
    if (priceDisplay && opt.dataset.variantPrice) priceDisplay.textContent = opt.dataset.variantPrice;
    if (soldOutBadge) soldOutBadge.hidden = available;
    if (stockStatusText) stockStatusText.textContent = available ? "AUF LAGER" : "NICHT VORRÄTIG";
    if (addToCartBtn) {
      addToCartBtn.disabled = !available;
      addToCartBtn.classList.toggle("btn--disabled", !available);
      addToCartBtn.textContent = available ? "In den Warenkorb" : "Ausverkauft";
    }
  }

  select.addEventListener("change", applySelection);
  applySelection();
});
